/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
class s{constructor(s,r,t,e){this.storage=s,this.proxy=r,this.viewParams=t,this.registry=e}async createMeshWriters(s){const r=s.map((s=>this.registry.createMeshWriter(this.storage,this.proxy,this.viewParams,s)));return Promise.all(r)}}export{s as MatcherContext};
